import axios, { AxiosRequestHeaders } from 'axios';
import { remoteConfigGetter } from "../utils/remoteConfig";
import { ResponceStatusService } from "../sub";

const globalHeaders: AxiosRequestHeaders = {
    'Content-Type': 'application/json',
    "X-Application-Id": String(process.env.REACT_APP_TV_APPLICATION_ID),
    "X-Stage": String(process.env.REACT_APP_ENV),
}
export const apiFlowBackend = axios.create({
    baseURL: remoteConfigGetter('vortex_url_v2').asString(),
    headers: globalHeaders
});

export const waveBackend = axios.create({
    baseURL: remoteConfigGetter('vortex_url_v2').asString(),
    headers: {
        'Content-Type': 'application/json',
    },
});

function authorizedHeaders(token: string) {
    return { ...globalHeaders, 'Authorization': `Bearer ${token}` }
}

async function SsoLogin(body: any) {
    return await apiFlowBackend.post('aux/authentication/v2/verifySso', body);
}

async function refreshLogin(data: any, token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.post('aux/authentication/refreshLogin', data, { headers: headers });
}

async function getTotalMargin(data: any, token: string) {
    let headers = authorizedHeaders(token);
    return await apiFlowBackend.post('margins/basket', data, { headers: headers });
}

async function getOptionUserPreferences(formValues: any, token: string) {
    var headers = { ...globalHeaders, 'Authorization': "Bearer " + token }
    return await apiFlowBackend.get('aux/user/preferences', { headers: headers });

}
async function setUseroptionPreferences(formValues: any, token: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token };
    return await apiFlowBackend.put('aux/user/preferences', formValues, { headers: headers });
}

async function getHistoricalOHLC(token: string, segmentId: number, accesstoken: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + accesstoken };
    return await apiFlowBackend.get('aux/highLow?token=' + token + "&market_segment_id=" + segmentId, { headers: headers })
}

async function getFutures(formValues: any, token: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token };
    return axios.post(remoteConfigGetter('vortex_url_v2').asString() + 'aux/futurechain', formValues, { headers: headers });
}

async function getStrategies(formValues: any, token: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token };
    return axios.post(remoteConfigGetter('vortex_url_v2').asString() + 'strategies', formValues, { headers: headers });
}

async function getPayOff(formValues: any, token: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token };
    var aa = remoteConfigGetter('vortex_url_v2').asString()
    return axios.post(remoteConfigGetter('vortex_url_v2').asString() + 'strategies/payoff', formValues, { headers: headers });
}

async function getAvailableFunds(token: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token };
    return apiFlowBackend.get('user/funds', { headers: headers });
}

async function getBuilderStrategies(formValues: any, token: string) {
    var headers = { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token };
    return axios.post(remoteConfigGetter('vortex_url_v2').asString() + 'strategies/build', formValues, { headers: headers });
}



apiFlowBackend.interceptors.response.use(undefined, err => {
    const error = err.response;
    if (error?.status === 401) {
        ResponceStatusService.sendRes({ type: 'FLOW', status: 401 });
    }
    return Promise.reject(err);
});





const flowBackEndServices2 = {
    refreshLogin, getTotalMargin, getOptionUserPreferences, setUseroptionPreferences
    , getHistoricalOHLC, getFutures, getStrategies, getPayOff, getAvailableFunds, getBuilderStrategies, SsoLogin
};

export default flowBackEndServices2;
